export const transformGlobalReviews = bookingReviewAggregate =>
  bookingReviewAggregate.review_aggregates.items.reduce((itemsAcc, item) => {
    if (!item.review) {
      return {
        apAverage: itemsAcc.apAverage,
        apCount: itemsAcc.apCount,
        totalApOverallGrades: itemsAcc.totalApOverallGrades,
        propertyAverage: itemsAcc.propertyAverage,
        propertyCount: itemsAcc.propertyCount,
        totalPropertyOverallGrades: itemsAcc.totalPropertyOverallGrades
      };
    }

    const {
      summary_aggregate: {
        accommodation_provider_grades_aggregate: {
          grades_average: { items: apSummaryReviews }
        },
        property_grades_aggregate: {
          grades_average: { items: propertySummaryReviews }
        }
      }
    } = bookingReviewAggregate;

    const { apAverage, apCount, totalApOverallGrades } = transformApReviews({
      itemsAcc,
      apSummaryReviews,
      itemReview: item.review
    });

    const { propertyAverage, propertyCount, totalPropertyOverallGrades } = transformPropertyReviews({
      itemsAcc,
      propertySummaryReviews,
      itemReview: item.review
    });

    return {
      apAverage,
      apCount,
      totalApOverallGrades,
      propertyAverage,
      propertyCount,
      totalPropertyOverallGrades
    };
  }, {});

export const round = value => {
  const multiplier = Math.pow(10, 1);

  return Math.round(value * multiplier) / multiplier;
};

const evaluateGrade = items =>
  round(
    items.reduce((acc, grade) => {
      if (!grade.value) {
        return acc;
      }

      return acc ? (acc + grade.value) / 2 : grade.value;
    }, 0)
  );

const transformApReviews = ({ itemsAcc, apSummaryReviews, itemReview }) => {
  const apAverage = evaluateGrade(apSummaryReviews);
  const apCount = itemReview.accommodation_provider_review ? (itemsAcc.apCount ?? 0) + 1 : itemsAcc.apCount ?? 0;
  const totalApOverallGrades = mapOverallGrades(apSummaryReviews, itemsAcc.totalApOverallGrades);

  return { apAverage, apCount, totalApOverallGrades };
};

const transformPropertyReviews = ({ itemsAcc, propertySummaryReviews, itemReview }) => {
  const propertyAverage = evaluateGrade(propertySummaryReviews);
  const propertyCount = itemReview.property_review ? (itemsAcc.apCount ?? 0) + 1 : itemsAcc.apCount ?? 0;
  const totalPropertyOverallGrades = mapOverallGrades(propertySummaryReviews, itemsAcc.totalPropertyOverallGrades);

  return { propertyAverage, propertyCount, totalPropertyOverallGrades };
};

const mapOverallGrades = (overallGrades, totalOverallGrades = {}) =>
  overallGrades.reduce(
    (acc, grade) => ({ ...acc, [grade.code]: acc[grade.code] ? (acc[grade.code] + grade.value) / 2 : grade.value }),
    totalOverallGrades
  );

export const getBestReview = (reviews = []) =>
  reviews.reduce((acc, item) => {
    const {
      review: {
        property_review: {
          content: { grades_average }
        }
      }
    } = item;

    return grades_average > acc ? grades_average : acc;
  }, 0);
